import { render, staticRenderFns } from "./Computadores.vue?vue&type=template&id=5efe9415&"
import script from "./Computadores.vue?vue&type=script&lang=ts&"
export * from "./Computadores.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports